import styled from '@emotion/styled';
import { Button as HotSauceButton, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { SessionNotRecordedPopover } from './SessionNotRecordedPopover';

const PlayButton = styled(HotSauceButton)`
  ${(props) => {
    // We need to do this so we prevent reset the angular global a tag styles.
    // This is done only for when the button is used as an a tag so we will not
    // have the styles applied for when the button is disabled.
    if (props.as === 'a') {
      return `&:active,
        &:hover,
        &:focus,
        &:visited {
          text-decoration: none;
          color: ${tokens.color.white};
        }`;
    }

    return null;
  }}
`;

interface RecordingButtonLinkProps {
  trackClick: () => void;
  trackHover: () => void;
  href?: string;
}

export function RecordingButtonLink({
  trackClick,
  trackHover,
  href,
}: RecordingButtonLinkProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'surveys.responses-list.recording' });

  return href !== undefined ? (
    <PlayButton icon="play_alt" as="a" isExternal href={href} onClick={trackClick}>
      {t('play-recording')}
    </PlayButton>
  ) : (
    <SessionNotRecordedPopover onShow={trackHover}>
      <PlayButton isDisabled icon="play_alt">
        {t('play-recording')}
      </PlayButton>
    </SessionNotRecordedPopover>
  );
}
